var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./CommonSearchInput.jinja');
require('./CommonSearchInput.less');

module.exports = Base.extend({

    el: '.CommonSearchInput',

    events: {
        'keydown .CommonSearchInput-searchInput': 'onInputKeyDown',
        'input .CommonSearchInput-searchInput': 'onInputInput',
        'click .CommonSearchInput-searchIcon': 'onInputIconClick',
        'blur .CommonSearchInput-searchInput': 'onInputBlur'
    },


    initialize: function (options) {
        this.options = options || {};

        Base.prototype.initialize.call(this, options);
    },


    setValue: function (val) {
        this.$('.CommonSearchInput-searchInput').val(val);
    },


    onInputBlur: function () {
        this.trigger('blur');

        var $tip = this.$('.CommonSearchInput-form-search-tip');
        var tipClass = 'CommonSearchInput-form-search-tip--show';

        clearTimeout(this.tipTimeout);
        $tip.removeClass(tipClass);
    },


    onInputKeyDown: function (e) {
        var $input = $(e.currentTarget);
        var query = $.trim($input.val());
        var $tip = this.$('.CommonSearchInput-form-search-tip');
        var tipClass = 'CommonSearchInput-form-search-tip--show';

        if (e.keyCode == 13 && (query.length > 2 || query.length == 0)) { //enter
            clearTimeout(this.tipTimeout);
            $tip.removeClass(tipClass);
            app.settings.isDesktop && app.utils.getFocusBack();
            this.tipWasShownOnce = true;
            this.trigger('enter-pressed', query);
        }
    },


    onInputInput: function (e) {
        var $input = $(e.currentTarget);
        var query = $.trim($input.val());
        var $tip = this.$('.CommonSearchInput-form-search-tip');
        var tipClass = 'CommonSearchInput-form-search-tip--show';
        var isShown = !!query && !this.tipWasShownOnce;

        clearTimeout(this.tipTimeout);

        this.tipTimeout = setTimeout(function () {
            $tip.toggleClass(tipClass, isShown);
        }.bind(this), isShown ? 1000 : 0);
    },


    onInputIconClick: function () {
        setTimeout(function () {
            this.$('.CommonSearchInput-searchInput').focus();
        }.bind(this), 100);
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/CommonSearchInput/CommonSearchInput.js
// module id = 37
// module chunks = 0